import * as React from "react";
import { NumericFormat } from "react-number-format";
import InputAdornment from "@mui/material/InputAdornment";
import { SxProps, TextField, Theme } from "@mui/material";

interface CustomCurrencyComponentProps {
  displayType?: any;
  onValue?: (value: any) => void;
  controlDisabled?: boolean;
  value?: number | string;
  helperText?: string | null | undefined;
  error?: boolean;
  label?: string;
  sx?: SxProps<Theme>;
  placeholder?: string;
  required?: boolean;
  hiddenLabel?: boolean;
}

export const CustomCurrencyComponent = ({
  onValue,
  displayType,
  controlDisabled,
  value,
  sx,
  placeholder,
  required,
  hiddenLabel,
  ...others
}: CustomCurrencyComponentProps) => (
  <NumericFormat
    {...others}
    hiddenLabel={hiddenLabel}
    required={required}
    placeholder={placeholder}
    sx={[...(Array.isArray(sx) ? sx : [sx])]}
    customInput={TextField}
    slotProps={{
      input: {
        startAdornment: <InputAdornment position="start">€</InputAdornment>,
      },
    }}
    disabled={controlDisabled}
    readOnly={controlDisabled}
    decimalSeparator=","
    thousandSeparator="."
    inputMode="numeric"
    decimalScale={2}
    displayType={displayType ? displayType : "input"}
    fixedDecimalScale
    onFocus={(event) => {
      event.target.select();
    }}
    valueIsNumericString={true}
    value={value}
    onValueChange={(values) => {
      const { floatValue } = values;
      if (onValue) onValue(floatValue);
    }}
  />
);

export default CustomCurrencyComponent;
